import Icon from "./Icon";
import { IconProps } from "./index";

const RightarrowIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <title>Arrow Icon</title>
      <rect
        x="0.492188"
        y="12.0771"
        width="23.2346"
        height="0.986085"
        fill="#396AFC"
      />
      <rect
        x="18.5664"
        y="16.8287"
        width="7.0089"
        height="0.986085"
        transform="rotate(-45 18.5664 16.8287)"
        fill="#396AFC"
      />
      <rect
        x="19.2627"
        y="7.61401"
        width="7.0089"
        height="0.986085"
        transform="rotate(45 19.2627 7.61401)"
        fill="#396AFC"
      />
    </Icon>
  );
};

export default RightarrowIcon;
